import '../css/login-registration.scss';
import $ from '@modules/jquery-import';
import Modernizr from 'modernizr';
import mediaQuery from '@util/media-queries';
import Module from '@core/Module';
import RegistrationService from '@services/RegistrationService/index';
import {jqueryValidate} from '@modules/lazy-imports';

$( document ).ready( async function () {

    await jqueryValidate();

    var regApp = (new Registration).initialize( '#newCustomerRegistration' );
} );

var Registration = function () {

    var conf = {
        fx_speed: 250
    };

    return $.extend( {
        elements: {
            '#newCustomerShippingAddress': 'shipping',
            '#newCustomerShippingAddress input, #newCustomerShippingAddress select': 'shippingFields',
            '#newCustomerBillingAddress': 'billing',
            '#SameAsShipping': 'sameAsShipping',
            '#shipcitystateValue': 'shippingCityStateValue',
            '#billcitystateValue': 'billingCityStateValue',
            'select[id$="citystate"]': 'citystateSelect'
        },

        events: {
            'change sameAsShipping': 'toggle_billing',
            'keyup input.zipCode': 'handle_zipcode',
            'input input.zipCode': 'handle_zipcode',
            'click .button.validate': 'handle_form_submit',
            'submit form[name="aspnetForm"]': 'handle_form_submit',
            'change shippingFields': 'toggle_billing'
        },

        initialize: function ( el ) {
            this.el = $( el );
            this.update_elements();
            this.delegate_events();

            // show the City/State fields by default to improve UX - currently set to display: none on server
            $( '#newCustomerShippingAddress, #newCustomerBillingAddress' ).each( function () {
                'use strict';
                var $cont = $( this ),
                    $lis = $cont.find( 'ol li' ),
                    $citySelect;

                $lis.eq( 3 ).find( '.hint' ).appendTo( $lis.eq( 4 ).find( 'label:first' ) );
                $citySelect = $cont.find( 'ol li:last-child select' );
                $citySelect.find( 'option' ).text( 'Enter ZIP Code to left' );
                //                $citySelect.trigger( 'change' );
            } );

            var registration = this.validation = $( '#newCustomerRegistrationForm' ).validate();

            // only validate fields inside registration container
            $.validator.addMethod( 'pageRequired', function ( value, element ) {
                if ( $( element ).parents( '#newCustomerRegistration' ).length ) {
                    return !registration.optional( element );
                }

                return 'dependency-mismatch';
            }, $.validator.messages.required );

            // if zipcode fields are already populated, get city list & set selected value
            this.el.find( '.zipCode' ).each( this.proxy( function ( i, item ) {
                if ( item.value && item.value.length == 5 ) {
                    this.get_city_list( item, true ).then( this.proxy( function () {
                        // toggle sameAsShipping once the state field has been generated
                        if ( this.sameAsShipping.is( ':checked' ) ) {
                            this.toggle_billing();
                        }
                    } ) );
                }
            } ) );

            // hide city/state fields if less than two options are present
            this.el.find( '[id$="citystate"]' ).each( function () {
                if ( this.options.length < 2 ) {
                    $( this ).parent( 'li' ).hide();
                }
            } );

            // Mobile interactions
            if ( Modernizr.mq( mediaQuery.max.screenMedium ) ) {
                // scroll and focus city/state select upon zipcode match
                this.bind( 'address:results', function ( e, $el ) {
                    $el.parents( 'li' ).scrollToElement();
                    $el[0].focus();
                } );
            }

        },

        handle_form_submit: function ( e ) {
            var valid = this.validation.form();
            return valid;
        },

        /**
         * extract element id from SharePoint hash, the id should be the characters appearing after the last occurence of '_'
         * @param  {String} str idattribute from a DOM node
         * @return {String}     the id extracted from a SharePoint element hash id
         */
        sanitize_id: function ( str ) {
            var arr = str.split( '_' );
            return arr[arr.length - 1];
        },

        copy_shipping: function () {
            var self = this,
                ship_form = this.shipping.find( 'ol' ),
                results = {},
                key = null;

            ship_form.find( 'input, select' ).each( function ( i, item ) {
                key = self.sanitize_id( item.id );
                switch ( item.type ) {
                    case 'select-one':
                        results[key] = item[item.selectedIndex].innerHTML;
                        break;

                    default: // item.type == 'text'
                        results[key] = item.value;
                }
            } );

            return results;
        },

        toggle_billing: function ( e ) {
            var bill_form = this.billing.find( 'ol' ),
                checkbox = this.sameAsShipping;

            if ( checkbox.is( ':checked' ) ) {
                // exit method if shipping address does not validate
                if ( !this.validate_section( this.shipping ) ) {
                    e && e.preventDefault();
                    checkbox[0].checked = false;
                    checkbox.change();
                    checkbox.parent( 'span' )
                        .next()
                        .showHint( 'Please complete required fields before selecting this option.' );
                    return;
                }

                // hide shipping form and generate copy of shipping address
                bill_form.slideUp( conf.fx_speed );
                this.render_shipping_copy( this.copy_shipping() );
            }
            else {
                // remove copy of shipping and show billing form
                if ( this.billing.shippingCopy ) {
                    this.billing.shippingCopy.slideUp( conf.fx_speed, function () {
                        $( this ).remove();
                    } );
                }
                bill_form.slideDown( conf.fx_speed );
            }
        },

        render_shipping_copy: function ( obj ) {
            // delete any existing addresses
            this.billing.find( 'address' ).hide( 400, function () {
                $( this ).remove();
            } );

            var $addr = $( '<address />' ).addClass( 'selectedAddress' );

            for ( var key in obj ) {
                // TODO: remove shipcitystate patch from .copy_shipping()
                if ( obj.hasOwnProperty( key ) && key != 'shipzipcode' && key != 'shipcitystateValue' ) {
                    $addr.append( '<span class="' + key + '">' + obj[key] + '</span>' );
                }
            }
            // format zipcode on City/State line
            $addr.find( '.shipcitystate' ).append( ' ' + obj['shipzipcode'] );

            this.billing.shippingCopy = $addr;
            $addr.insertBefore( this.billing.find( 'ol' ) ).hide().slideDown( conf.fx_speed );
        },

        handle_zipcode: function ( e ) {
            var keycode = (typeof e.which === 'number')
                ? e.which
                : e.keycode,
                val = e.target.value;

            if ( val === this.currentZipCode ) {
                return;
            }
            // only call service if last key pressed was a digit
            // and field contains 5 digit zipcode characters
            (val.length === 5)
                ? this.get_city_list( e.target )
                : this.render_city_select( e.target, null );

            this.currentZipCode = val;
        },

        get_city_list: function ( elm, ignoreLoading ) {

            if ( !ignoreLoading ) {
                this.city_select_loading( elm );
            }

            return RegistrationService.getCitiesFromPostalCode( elm.value )
                .then( data => this.render_city_select( elm, data ) )
                .catch( err => this.render_city_select( elm, [] ) );
        },

        render_city_select: function ( target, citylist ) {
            var targetType = target.id && (target.id.search( 'shipzip' ) !== -1)
                ? 'ship'
                : 'bill',
                focus_select = false,
                select_field,
                select_field_value,
                select_value_hiddenfield,
                options = [];

            if ( !targetType ) {
                return;
            }

            select_field = this.citystateSelect.filter( function ( i, item ) {
                return item.id.search( targetType ) !== -1;
            } );

            switch ( targetType ) {
                case 'bill':
                    select_value_hiddenfield = this.billingCityStateValue;
                    break;
                case 'ship':
                default:
                    select_value_hiddenfield = this.shippingCityStateValue;
                    break;
            }

            if ( !citylist ) {
                options.push( '<option value="">Enter ZIP Code to left</option>' );
                select_value_hiddenfield.val( '' );
                select_field_value = '';
            }
            else if ( citylist && citylist.length > 0 ) {
                select_field_value = select_value_hiddenfield.val();
                options.push( '<option value="">City, Country, State</option>' );

                citylist.forEach( ( {city, state, county} ) =>
                    options.push( `<option value="${city}~${county}~${state}">${city}, ${state}</option>` )
                );

                focus_select = !(typeof select_field_value !== 'undefined' && select_field_value !== '');
            }
            else {
                options.push( '<option value="">No Matches</option>' );
                select_value_hiddenfield.val( '' );
                select_field_value = '';
            }

            select_field.empty().html( options.join( '' ) );

            // must trigger "onchange" events manually when changing select fields programmatically
            console.log( 'select_field_value', select_field_value );
            select_field.val( select_field_value || '' );
            select_field.trigger( 'change' );
            focus_select && this.trigger( 'address:results', [select_field] );
        },

        city_select_loading: function ( target ) {
            // refactor duplicates above method
            var targetType = target.id && (target.id.search( 'shipzip' ) !== -1)
                ? 'ship'
                : 'bill',
                select_field,
                select_field_value,
                select_value_hiddenfield,
                options = [];

            if ( !targetType ) {
                return;
            }

            select_field = this.citystateSelect.filter( function ( i, item ) {
                return item.id.search( targetType ) !== -1;
            } );

            switch ( targetType ) {
                case 'bill':
                    select_value_hiddenfield = this.billingCityStateValue;
                    break;
                case 'ship':
                default:
                    select_value_hiddenfield = this.shippingCityStateValue;
                    break;
            }

            options.push( '<option value="">Searching...</option>' );
            select_value_hiddenfield.val( '' );
            select_field_value = '';

            select_field.empty().html( options.join( '' ) );

            if ( select_field_value !== '' ) {
                select_field.val( select_field_value );
            }

            // must trigger "onchange" events manually when changing select fields programmaticaly
            select_field.trigger( 'change' );
        },

        validate_section: function ( parent ) {
            var is_valid = true,
                items = $( this.validation.currentForm )
                    .find( 'input, select' )
                    .filter( ':not(:hidden)' )
                    .filter( function ( i, item ) {
                        return (item.id)
                            ? parent.find( '#' + item.id ).length
                            : false;
                    } );

            for ( var i = 0; i < items.length; i++ ) {
                // note: use strict equal "false" here due to logic within jquery.validates validator.check method
                // it wll return "undefined" for validation checks performed on optional elements, resulting in a false negative
                // comment from source: "If a method indicates that the field is optional and therefore valid,
                // don't mark it as valid when there are no other rules"
                if ( this.validation.check( items[i] ) === false ) {
                    is_valid = false;
                }
            }

            if ( !is_valid ) {
                this.validation.showErrors();
                setTimeout( function () {
                    $( this.validation.currentForm ).trigger( 'invalid-form', this.validation );
                }.bind( this ), 500 );
            }

            return is_valid;
        }

    }, Module );

};